<template>
  <div>
    <v-card-title class="heading">Adding an Investment Detail</v-card-title>
    <v-card-text class="input-text-size">
    <v-form ref="form">
      <ClarionDateControl
        id="investmentPurchaseDate"
        class="invest-trans-item-purchaseDate-date testSize"
        :isIsoDate="false"
        label="Date"
        v-model="editedItem.date"
        :rules="reqdSelectValidation"
        :isToggle="false"
      />
      <v-select
        class="testSize"
        id="entry-type"
        v-model="editedItem.entryType"
        :items="entryTypeEnums"
        item-text="description"
        item-value="name"
        label="Entry Type (Principal, Interest or Accrued Interest)"
        :rules="reqdSelectValidation"
      />
      <v-text-field
        class="testSize"
        label="Amount"
        type="number"
        v-model="editedItem.amount"
        :rules="reqdSelectValidation"
      />
      <v-text-field
        class="testSize"
        label="Description"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.description"
      />
      <v-checkbox
        v-model="editedItem.isReceipt"
        label="Has been Receipted"
      />
      </v-form>
    </v-card-text>
    <v-card-actions class="input-text-size">
      <v-btn color="primary" small @click="upsertTransaction">Save</v-btn>
      <v-btn small @click="closeEditDialog">Close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { amountToNumber, extractId } from '../../../util/shared/vue-global';
import { toIsoDate } from '../../../util/shared/tmc-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'InvestmentDetailsEditedItem',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
  },
  data: () => ({
    baseCrudKeyInve: 'investments',
    resultUpdatedItem: '',
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'investments',
    },
    responseInvestment: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'criteria']),
    ...mapState({
      principleOrIntrestTypeEnum: (state) => state.enums.GlEntryPrincipleOrIntrestTypeEnum,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    entryTypeEnums() {
      if (!this.principleOrIntrestTypeEnum) {
        return [];
      }
      return this.principleOrIntrestTypeEnum;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem', 'setItems']),
    ...mapActions('glDaily/glInvestmentTransaction', [
      'upsertInvestDetailsTransaction',
    ]),
    ...mapMutations('glDaily/glInvestmentTransaction', [
      'setSelectedItems',
    ]),
    closeEditDialog() {
      this.editedItem = {};
      this.$emit('update:editFeesDialog', false);
    },
    async upsertTransaction() {
      const result = this.$refs.form.validate();
      if (result) {
        try {
          const updatedItem = { ...this.item(this.baseCrudKeyInve) } || {};
          const detailsResult = {};
          detailsResult._id = extractId(updatedItem._id);
          /* Get index */
          const detailIndex = this.editedItem.index;
          if (typeof detailIndex === 'number') {
            detailsResult.index = detailIndex;
          } else {
            detailsResult.index = null;
          }

          const detailsObject = {};
          detailsObject.date = toIsoDate(this.editedItem.date);
          detailsObject.amount = amountToNumber(this.editedItem.amount);
          detailsObject.description = this.editedItem.description;
          detailsObject.isReceipt = this.editedItem.isReceipt;
          detailsObject.entryType = this.editedItem.entryType;
          detailsResult.details = detailsObject;
          delete updatedItem.interestAmount;
          delete updatedItem.principalAmount;
          delete updatedItem.daysBetweenDates;
          const response = await this.upsertInvestDetailsTransaction({
            item: detailsResult,
            baseCrudKey: this.baseCrudKey,
          });
          this.closeEditDialog();
          this.$nextTick(() => {
            this.setSelectedItems([]);
          });
          return response;
        } catch (error) {
          console.error('Error upserting transaction:', error);
          return null;
        }
      } else {
        return null;
      }
    },

  },
};
</script>

<style scoped>
.heading{
  display: flex;
    justify-content: center;
    margin-bottom: 10px ;
}
.testSize{
  font-size: 14px;
}
</style>
